export const giftAddressDescription = '※電子ギフト券はメールで届きます。配送先は受け取り側が指定します。'
